import AdminArticleFirestoreDictionary from "./adminArticleFirestoreDictionary";

export default function AdminArticleCategories() {
  return (
    <AdminArticleFirestoreDictionary
      heading="Article categories"
      collectionName="articleCategories"
    />
  );
}
